import { Button } from '@mui/material'
import React, { useMemo, useState } from 'react'
import "./Heading.css"
import { ConfirmationPopUp } from '../popup/confirmationPopUp';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';
type configurationHeaderProps= {
    heading:string;
    showBackButton?:boolean;
    saveConfiguration?:()=>void;
    createPreview?:()=>void;
    disable?: boolean;
    importConfiguration?:()=>void;
    showConfirmPopup?: boolean;
}

const ConfigurationHeader = (props:configurationHeaderProps) => {
  const { translate } = usePortalTranslation();
  const [openConfirmationModal, setOpenConfirmModal] = useState(false)
  function handleSaveButton(){
    if(props.showConfirmPopup){
        setOpenConfirmModal(true);
    }else if(props.saveConfiguration){
        props.saveConfiguration();
    }
  }
  const isAdmin = useMemo(() => {
    const desginations = JSON.parse(localStorage.authContext)?.user?.designation;
    return desginations.includes("admin");;
  },[])
  return (
         <div className="main_form_header">
                <ConfirmationPopUp message="Are you sure you want to save?"
                    openConfirmModal={openConfirmationModal}
                    setOpenConfirmModal={setOpenConfirmModal}
                    successMethod={props.saveConfiguration}/>
                <span className="main_heading">{translate(TranslationEnum.ui_config, props.heading)}</span>
                <span>
                    {isAdmin && props.importConfiguration && <Button disabled={props.disable} variant="contained" className="order_button" onClick={props.importConfiguration}>Import</Button>}
                    {props.saveConfiguration && <Button disabled={props.disable} variant="contained" className="order_button" onClick={handleSaveButton}>{translate(TranslationEnum.ui_config, "Save")}</Button>}
                    {props.createPreview && <Button variant="contained" disabled className="order_button" onClick={props.createPreview}>{translate(TranslationEnum.ui_config, "Review")}</Button>}
                    {props.showBackButton && <button className="default-back-button" onClick={() => {window.history.back();}} style={{marginLeft:"10px"}}>{translate(TranslationEnum.ui_config, "BACK")}</button>}
                </span>
            </div>
  )
}

export default ConfigurationHeader